import { useFormContext } from '@calendly/form'

import { useEventTypeContext } from 'features/event_type_provider'

import { filterEnabledMemberships } from '../helpers'
import { Availability } from './availability'
import { ActiveAvailableHours } from './available_hours/active_available_hours'
import {
  AvailabilitySidePanel,
  AvailabilitySidePanelProvider,
} from './available_hours/components/availability_side_panel'
import { ScheduleControls } from './available_hours/components/schedule_controls'
import { V4AvailableHours } from './crud/v4_available_hours'
import { findAvailabilityMembership } from './helpers'
import { Range } from './range'

const getPrimaryMembershipFormPath = ({
  eventType,
  eventTypeMembershipsAttributes,
  memberships,
}) => {
  if (eventType.isMETParent || !eventTypeMembershipsAttributes || !memberships) return null

  const [membership] = eventType.isTeam ? filterEnabledMemberships(memberships) : memberships
  const formMembership = findAvailabilityMembership(eventTypeMembershipsAttributes, membership)
  const formMembershipIndex = eventTypeMembershipsAttributes.indexOf(formMembership)

  return formMembershipIndex >= 0 ? `event_type_memberships_attributes.${formMembershipIndex}` : null
}

export const CrudAvailability = ({
  isLocked = false,
  isReadOnly = false,
  variant = 'legacy',
  includeSchedulingWindow = true,
  onViewCalendarInPreview,
  isCalendarPreviewActive = false,
  onClearCalendarPreview,
}) => {
  const { eventType } = useEventTypeContext()
  const {
    values: {
      event_type_memberships_attributes: eventTypeMembershipsAttributes,
      memberships,
    },
  } = useFormContext()
  const formPath = getPrimaryMembershipFormPath({
    eventType,
    eventTypeMembershipsAttributes,
    memberships,
  })

  if (!formPath) {
    return <Availability isLocked={isLocked} isReadOnly={isReadOnly} />
  }

  if (variant === 'v4') {
    return (
      <V4AvailableHours
        formPath={formPath}
        isLocked={isLocked}
        isReadOnly={isReadOnly}
        onViewCalendarInPreview={onViewCalendarInPreview}
        isCalendarPreviewActive={isCalendarPreviewActive}
        onClearCalendarPreview={onClearCalendarPreview}
      />
    )
  }

  return (
    <AvailabilitySidePanelProvider>
      <ScheduleControls
        formPath={formPath}
        isLocked={isLocked}
        isReadOnly={isReadOnly}
      />
      <ActiveAvailableHours
        formPath={formPath}
        isLocked={isLocked}
        isReadOnly={isReadOnly}
      />
      {includeSchedulingWindow && <Range isLocked={isLocked || isReadOnly} />}
      <AvailabilitySidePanel />
    </AvailabilitySidePanelProvider>
  )
}
